import { getAuthHeaders } from '~/api/helpers'
import HttpFactory from '~/api/http-factory'
import AuthScope from '~/enums/auth-scope'

export default class LayerSpecialOffers extends HttpFactory {
  private readonly resource = 'v1/layerSpecialOffers'

  public createLayerSpecialOffer (data: object, authScope: AuthScope) {
    return this.$fetch(
      this.resource,
      { method: 'POST', body: data, headers: getAuthHeaders(this.authStore.token, authScope) }
    )
  }

  public deleteLayerSpecialOffer (id: string) {
    return this.$fetch(
      `${this.resource}/${id}`,
      { method: 'DELETE', headers: getAuthHeaders(this.authStore.token, AuthScope.Admin) }
    )
  }

  public getLayerSpecialOffer (id: string, authScope: AuthScope) {
    return this.$fetch(
      `${this.resource}/${id}`,
      { headers: getAuthHeaders(this.authStore.token, authScope) }
    )
  }

  public getLayerSpecialOffers (params: object, authScope: AuthScope) {
    return this.$fetch(this.resource, { headers: getAuthHeaders(this.authStore.token, authScope), params })
  }

  public updateLayerSpecialOffer (id: string, data: object, authScope: AuthScope) {
    return this.$fetch(
      `${this.resource}/${id}`,
      { method: 'PUT', body: data, headers: getAuthHeaders(this.authStore.token, authScope) }
    )
  }

  public syncLayerProductSpecialOffer (id: string, data: any, authScope: AuthScope) {
    return this.$fetch(
      `${this.resource}/${id}/relationships/sync`,
      { method: 'POST', body: data, headers: getAuthHeaders(this.authStore.token, authScope) }
    )
  }
}
